import { render, staticRenderFns } from "./UserProgressDiagram.vue?vue&type=template&id=5ce168a4&scoped=true&"
import script from "./UserProgressDiagram.vue?vue&type=script&lang=js&"
export * from "./UserProgressDiagram.vue?vue&type=script&lang=js&"
import style0 from "./UserProgressDiagram.vue?vue&type=style&index=0&id=5ce168a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce168a4",
  null
  
)

export default component.exports